import { Button } from "@atgis/ui";
import { ArrowRight, Mail, Phone } from "lucide-react";

export function Cta() {
  return (
    <section id="iletisim" className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-gradient-to-br from-primary/10 via-[hsl(155_55%_38%)]/12 to-[hsl(165_65%_50%)]/10"
        aria-hidden
      />
      <div className="container relative py-20 md:py-28">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-balance text-3xl font-semibold tracking-tight md:text-5xl">
            Ekibinizin sahaya çıkarken <span className="gradient-text">tek bir kaynaktan</span>{" "}
            beslendiği günü kuralım.
          </h2>
          <p className="mt-5 text-pretty text-base text-muted-foreground md:text-lg">
            RADGIS Platform'u sizin verinizle, sizin veri modelinizle canlı görmek ister misiniz?
            Bir saat içinde uçtan uca demo planlayabiliriz.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Button size="lg" asChild>
              <a href="mailto:hello@radgis.com.tr">
                Demo İste <ArrowRight />
              </a>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <a href="#urun">Ürünü Tekrar Gez</a>
            </Button>
          </div>

          <div className="mt-10 grid gap-4 sm:grid-cols-2">
            <a
              href="mailto:hello@radgis.com.tr"
              className="flex items-center gap-3 rounded-xl border border-border/60 bg-card/60 p-4 text-left transition-colors hover:bg-accent"
            >
              <div className="grid h-10 w-10 place-items-center rounded-lg bg-muted">
                <Mail className="h-4 w-4" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-muted-foreground">
                  E-posta
                </div>
                <div className="text-sm font-medium">hello@radgis.com.tr</div>
              </div>
            </a>
            <a
              href="tel:+905412769700"
              className="flex items-center gap-3 rounded-xl border border-border/60 bg-card/60 p-4 text-left transition-colors hover:bg-accent"
            >
              <div className="grid h-10 w-10 place-items-center rounded-lg bg-muted">
                <Phone className="h-4 w-4" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-muted-foreground">
                  Telefon
                </div>
                <div className="text-sm font-medium">+90 (541) 276 97 00</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
